import {
    ChangeDetectionStrategy, Component, HostListener, Input,
    OnDestroy,
    Optional,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectAllDirective } from "./select-all.directive";
import { SelectSelfDirective } from "./select-self.directive";

@Component({
    selector: "selectable",
    templateUrl: "./selectable.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectableComponent implements OnDestroy {
    @Input() public detailId;

    public changeDetectionInterval$: Subscription;

    constructor(
        @Optional() public selectSelf: SelectSelfDirective,
        @Optional() public selectAll: SelectAllDirective,
    ) {
    }

    public ngOnDestroy() {
        if (!!this.changeDetectionInterval$) { this.changeDetectionInterval$.unsubscribe(); }
    }

    public toggle() {
        (this.selectAll || this.selectSelf).toggle();
    }

    public get toggleState() {
        return (this.selectAll || this.selectSelf).toggleState;
    }

    @HostListener("click")
    public onClick() {
        this.toggle();
    }
}
